<template>
  <v-container>
    <v-layout row wrap>
      
      <!--
      <v-flex xs12 class="ma-2" style="font-family: 'Nico Moji'; ">
        <v-layout justify-center>
          <p>Here is development environment.</p>
        </v-layout>
        <v-layout justify-center>
          <p>Production environment is <a href="https://mosaic.w2or3w.com" target="_blank">there</a>.</p>
        </v-layout>
      </v-flex>
      -->

      <v-flex xs12 class="ma-2" style="padding-top: 16px;">
        <v-layout justify-center>
          <v-btn color="#3F51B5" class="ma-2 white--text " @click="selectFile">
            <v-icon color="white" left dark>mdi-face</v-icon>
            <v-icon color="white" left dark>mdi-face-woman</v-icon>
            SELECT A PHOTO !!
            <v-icon color="white" right dark>mdi-baby-face-outline </v-icon>
            <v-icon color="white" right dark>mdi-github-face </v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
      
      <v-flex xs12 class="ma-12 mt-8">
        <v-textarea
          :value="releaseNote" 
          required label="Release Note : " 
          outlined 
          rows="12" 
          readonly 
          disabled 
          wrap="off">
        </v-textarea>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { eventBus } from "../main";

export default {
  name: 'Home',
  data: () => ({
    releaseNote: `2020/3/22
 Changed mosaic processing call from API Gateway to AppSync.
 Change mosaic filter to Gaussian Blur.
-2020/3/1
  Use Cognito authentication and IAM authentication for AppSync.
-2020/2/1
  Detect object with Vision API (OBJECT_LOCALIZATION).
-2020/1/23
  Detect text with Vision API (TEXT_DETECTION).
-2019/12/21
  Refresh PWA cache methods.
-2019/12/15
  Add scroll up-down button. 
-2019/12/1
  Set up navigation-drawer menu. 
-2019/11/30
  Add download button.
-2019/11/29
  Add footer and SNS links.
  and Policy.
-2019/11/27
  Support PWA.
-2019/11/23
  Change the face detection engine 
  from OpenCV to Rekognition.
-2019/11/10
  Mosaic to selected faces.
  Update about page.
-2019/11/4
  Call API Gateway for mosaic.
- 2019/10/27
  Added the function for faces selection.
- 2019/10/20
  Resize large image on the client side.
  Wait by progress-circular for backend processing.
- 2019/10/15
  First deployment!
  Just extract & liist the faces from picture.
`
  }), 
  methods:{
    selectFile() {
      eventBus.$emit("onSelectImage");
    }, 
  }
}
</script>